import ReactDOM from "react-dom/client";

import App from "./App";
import "./styles/tailwind.scss";

const target = document.querySelector("#app");
const root = ReactDOM.createRoot(target as Element);

root.render(<App />);

if (module.hot) {
  module.hot.accept("./App", async () => {
    // Re-import the updated App module.
    const { default: UpdatedApp } = await import("./App");

    // Re-render the App.
    root.render(<UpdatedApp />);
  });
}
